const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS'
const USER_LIST_FAIL = 'USER_LIST_FAIL'
const USER_GET_SUCCESS = 'USER_GET_SUCCESS'
const USER_GET_FAIL = 'USER_GET_FAIL'
const USER_IMPERSONATE_SUCCESS = 'USER_IMPERSONATE_SUCCESS'
const USER_IMPERSONATE_FAIL = 'USER_IMPERSONATE_FAIL'
const USER_IMPERSONATE_STOP_SUCCESS = 'USER_IMPERSONATE_STOP_SUCCESS'
const USER_IMPERSONATE_STOP_FAIL = 'USER_IMPERSONATE_STOP_FAIL'
const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS'
const USER_CREATE_FAIL = 'USER_CREATE_FAIL'
const USER_UPDATE_SUCCESS_AND_LIST = 'USER_UPDATE_SUCCESS_AND_LIST'
const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL'
const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
const USER_DELETE_FAIL = 'USER_DELETE_FAIL'
const USER_TOGGLE_ENABLE_SUCCESS = 'USER_TOGGLE_ENABLE_SUCCESS'
const USER_TOGGLE_ENABLE_FAIL = 'USER_TOGGLE_ENABLE_FAIL'
const USER_RESET = 'USER_RESET'
const USER_IMPERSONATE_RESET = 'USER_IMPERSONATE_RESET'
const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS"
const SOFTWARE_UPDATE_STOP = 'SOFTWARE_UPDATE_STOP';
const GET_SOFTWARE_UPDATE_SUCCESS = 'GET_SOFTWARE_UPDATE_SUCCESS';
export const USERS_RESET = 'USERS_RESET'

export const defaultUserState = {
  users: null,
  user: null,
  userId: null,
  error: false,
  errorMessage: null,
  created: false,
  updated: false,
  impersonating: false,
  impersonatedUser: null,
  loggedInUserNameInitials: null,
  currentLoggedInUserId: null,
  softwareUpdate: false,
  softwareVersion: null
}

export default (state = defaultUserState, action) => {
  switch (action.type) {
    case USER_LIST_SUCCESS:
      return {
        ...state,
        users: action.payload.data
      }
    case USER_LIST_FAIL:
      return {
        ...state,
      }
    case USER_IMPERSONATE_SUCCESS:
      return {
        ...state,
        users: null,
        impersonatedUser: action.payload.data,
        impersonating: true,
        loggedInUserNameInitials: null,
        currentLoggedInUserId : action.payload.data.impersonateduserid
      }
    case USER_IMPERSONATE_FAIL:
      return {
        ...state,
        impersonatedUser: null,
        impersonating: false
      }
    case USER_IMPERSONATE_STOP_SUCCESS:
      return {
        ...state,
        impersonatedUser: action.payload.data,
        impersonating: false,
        loggedInUserNameInitials: null,
        currentLoggedInUserId: null
      }
    case USER_IMPERSONATE_STOP_FAIL:
      return {
        ...state,
      }
    case USER_CREATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          userId: action.payload.data.id,
          created: true,
          error: false
        }
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          created: false,
          error: true
        }
      }
    }
    case USER_CREATE_FAIL: {
      return {
        ...state,
      }
    }
    case USER_GET_SUCCESS: {
      const  User  = action.payload.data
      const loggedInUserNameInitials = state.loggedInUserNameInitials ||  ((User.firstname ? User.firstname.charAt(0) : '') + (User.lastname ? User.lastname.charAt(0) : ''))
      const currentLoggedInUserId = state.loggedInUserNameInitials ?  state.currentLoggedInUserId  : User.id
      return {
        ...state,
        loggedInUserNameInitials,
        currentLoggedInUserId,
        user: User
      }
    }
    case USER_GET_FAIL: {
      return {
        ...state,
      }
    }
    case USER_UPDATE_SUCCESS_AND_LIST: {
      if (action.payload.data.success) {
        return {
          ...state,
          userId: action.payload.data.id,
          updated: true,
          error: false
        }
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          updated: false,
          error: true
        }
      }
    }
    case USER_UPDATE_FAIL: {
      return {
        ...state,
      }
    }
    case USER_DELETE_SUCCESS: {
      return {
        ...state
      }
    }
    case USER_DELETE_FAIL: {
      return {
        ...state,
      }
    }
    case USER_TOGGLE_ENABLE_SUCCESS: {
      return {
        ...state
      }
    }
    case USER_TOGGLE_ENABLE_FAIL: {
      return {
        ...state,
      }
    }
    case USER_RESET: {
      return {
        ...state,
        user: null,
        userId: null,
        error: false,
        errorMessage: null,
        created: false,
        updated: false
      }
    }
    case USER_IMPERSONATE_RESET: {
      return {
        ...state,
        impersonatedUser: null,
        impersonating: false
      }
    }
    case USER_UPDATE_SUCCESS : {
      const  UserId  = action.payload.data.id
      const loggedInUserNameInitials = (state.currentLoggedInUserId === UserId) ?  undefined : (state.loggedInUserNameInitials)
      return {
        ...state,
        loggedInUserNameInitials
      }
    }
    case USERS_RESET : {
      return {
        ...state,
        users: null
      }
    }
    case SOFTWARE_UPDATE_STOP:
      return {
        ...state,
        softwareUpdate: false 
      }
    case GET_SOFTWARE_UPDATE_SUCCESS:
      return {
        ...state,
        softwareUpdate: action.payload.data.isUpdate,
        softwareVersion: action.payload.data
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/userReducer.js